import { render, staticRenderFns } from "./InteresadosPage.vue?vue&type=template&id=3aa76413&"
import script from "./InteresadosPage.js?vue&type=script&lang=js&"
export * from "./InteresadosPage.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports